export const decoratedPropertiesRegistry: { [className: string]: string[] } = {};

export function IdField(): PropertyDecorator {
  return function (target: Object, propertyKey: string | symbol) {
    const className = target.constructor.name;
    if (!decoratedPropertiesRegistry[className]) {
      decoratedPropertiesRegistry[className] = [];
    }
    decoratedPropertiesRegistry[className].push(propertyKey.toString());
  };
}

export function getIdFieldPropertyName(className: string): string | undefined {
  const properties = decoratedPropertiesRegistry[className] || [];
  return properties?.length ? properties[0] : undefined;
}
